import storage from 'local-storage-fallback';

export default class Cache {

    static get(id) {
        // Look in local storage for object
        let key = id; // this._getClassTypeName(id);
        let str = storage.getItem(key);
        if (str != null) {
            try {
                let object = JSON.parse(str);
                return object;

            } catch (e) {
                return null;
            }
        }

        return str;
    }

    static set(key, value) {
        storage.setItem(key, JSON.stringify(value));
    }

    static remove(key) {
        storage.removeItem(key);
    }

    static key(index) {
        throw "Not Implemented";
        return storage.key(index);
    }

    static size() {
        throw "Not Implemented";
        return window.localStorage.length;
    }

    // static _getClassTypeName(id: string): string {
    //     return id;
    // }

}